/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import { BloodPressureValuesFragmentDoc } from './BloodPressureProfile';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateBloodPressureProfileMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateBloodPressureInput;
}>;


export type UpdateBloodPressureProfileMutation = { __typename?: 'Mutation', updateBloodPressure: { __typename?: 'UpdateBloodPressurePayload', nextStepPath: string | null, form: { __typename?: 'BloodPressure', id: string, systolicPressure: number | null, diastolicPressure: number | null, lastTreatedAt: string | null, controlledWithMedication: boolean | null, controlledWithMedicationSince: string | null } } | null };


export const UpdateBloodPressureProfileDocument = gql`
    mutation UpdateBloodPressureProfile($input: UpdateBloodPressureInput!) {
  updateBloodPressure(input: $input) {
    form {
      id
      ...BloodPressureValues
    }
    nextStepPath
  }
}
    ${BloodPressureValuesFragmentDoc}`;
export type UpdateBloodPressureProfileMutationFn = Apollo.MutationFunction<UpdateBloodPressureProfileMutation, UpdateBloodPressureProfileMutationVariables>;
export function useUpdateBloodPressureProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBloodPressureProfileMutation, UpdateBloodPressureProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBloodPressureProfileMutation, UpdateBloodPressureProfileMutationVariables>(UpdateBloodPressureProfileDocument, options);
      }
export type UpdateBloodPressureProfileMutationHookResult = ReturnType<typeof useUpdateBloodPressureProfileMutation>;
export type UpdateBloodPressureProfileMutationResult = Apollo.MutationResult<UpdateBloodPressureProfileMutation>;
export type UpdateBloodPressureProfileMutationOptions = Apollo.BaseMutationOptions<UpdateBloodPressureProfileMutation, UpdateBloodPressureProfileMutationVariables>;